import { Orientation } from '@bg-shared/enums/Orientation';

export const getOrientation = (width: number, height: number): Orientation =>
    width > height ? Orientation.LANDSCAPE : Orientation.PORTRAIT;

export const isPortrait = (width: number, height: number): boolean =>
    getOrientation(width, height) === Orientation.PORTRAIT;
